// Every public discovery query (search, homepage, store and profile pages) goes through this, so
// none of them can forget the rule. The server keeps metadata.hiddenFromSearch on each published
// listing: true when the listing is private or its seller is on vacation
// (server/listing-search-visibility.js). Direct listing URLs still work.
export const HIDDEN_FROM_SEARCH_QUERY_PARAM = 'meta_hiddenFromSearch';
export const HIDDEN_FROM_SEARCH_PUBLIC_VALUE = false;

/**
 * Leave out private listings and listings from sellers on vacation.
 */
export const withPrivateListingsExcluded = (params = {}) => ({
  ...params,
  [HIDDEN_FROM_SEARCH_QUERY_PARAM]: HIDDEN_FROM_SEARCH_PUBLIC_VALUE,
});
